import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { APP_CONFIG } from "../../config/GeneralConfig";
import { eventNotificationShow } from "../common/EventNotificationActions";
import {EVENT_NOTIFICATION_TYPE} from "../../helpers/EventNotificationType";
import { UserWorkhours } from '../../models/users/User';
import { MenuItem } from '../../models/menu/Menu';


/**
 * typescript action definitions
 */
interface FetchMenuItemsAction {
    type: typeof FETCH_MENU_ITEMS
}
interface FetchMenuItemsSuccessAction {
    type: typeof FETCH_MENU_ITEMS_SUCCESS
    menu: MenuItem[]
}
interface FetchMenuItemsErrorAction {
    type: typeof FETCH_MENU_ITEMS_ERROR
    error: Error
}

interface FetchWorkhoursAction {
    type: typeof FETCH_WORKHOURS_CURRENT_WEEK
}
interface FetchWorkhoursSuccessAction {
    type: typeof FETCH_WORKHOURS_CURRENT_WEEK_SUCCESS
    workhours: UserWorkhours
} 
interface FetchWorkhoursErrorAction {
    type: typeof FETCH_WORKHOURS_CURRENT_WEEK_ERROR
    error: Error
}

type FetchMenuActionTypes = FetchMenuItemsAction | FetchMenuItemsErrorAction | FetchMenuItemsSuccessAction
type FetchWorkhoursActionTypes = FetchWorkhoursAction | FetchWorkhoursSuccessAction | FetchWorkhoursErrorAction
export type MainMenuActionTypes = FetchMenuActionTypes | FetchWorkhoursActionTypes

/**
 * redux action constants
 * @type {string}
 */
export const FETCH_WORKHOURS_CURRENT_WEEK = "FETCH_WORKHOURS_CURRENT_WEEK";
export const FETCH_WORKHOURS_CURRENT_WEEK_SUCCESS = "FETCH_WORKHOURS_CURRENT_WEEK_SUCCESS";
export const FETCH_WORKHOURS_CURRENT_WEEK_ERROR = "FETCH_WORKHOURS_CURRENT_WEEK_ERROR";

/**
 * initiates fetching workhours of current week for logged in user
 *
 * redux action function to fetch the users workhours of the current week. initiates the fetching
 *
 * @TODO: currently points to api version 1.6, this must be changed later
 */
export const fetchWorkhoursCurrentWeek = (): FetchWorkhoursAction => ({ type: FETCH_WORKHOURS_CURRENT_WEEK });

/**
 * passes the workhours of current week to the reducer
 *
 * json object shape: { workhoursOfCurrentWeek: X, mandatoryWorkhoursOfCurrentWeek: Y }
 */
export const fetchWorkhoursCurrentWeekSuccess = ( workhours: UserWorkhours ): FetchWorkhoursSuccessAction => ({ type: FETCH_WORKHOURS_CURRENT_WEEK_SUCCESS, workhours });

/**
 * passes fetching error to reducer
 */
export const fetchWorkhoursCurrentWeekError = ( error: Error ): FetchWorkhoursErrorAction => ({ type: FETCH_WORKHOURS_CURRENT_WEEK_ERROR, error });

/**
 * rxjs epic to fetch the json data from backend and pass the return to reducer
 */
export const fetchWorkhoursCurrentWeekEpic = ( action$: Observable<FetchWorkhoursActionTypes> ) =>
    action$.pipe(
      ofType(FETCH_WORKHOURS_CURRENT_WEEK),
      mergeMap( action => {
          const pathToV1_6 = APP_CONFIG.baseWeb + "";

          return ajax( APP_CONFIG.getRequestObject(pathToV1_6)).pipe(
              map( response => fetchWorkhoursCurrentWeekSuccess( response.response as UserWorkhours )),
              catchError( error => {
                  return of(
                      fetchWorkhoursCurrentWeekError( error),
                      eventNotificationShow(
                          EVENT_NOTIFICATION_TYPE.customAjaxError,
                          'Daten konnten nicht abgerufen werden, Fehlercode: '
                      )
                  );
              } )
          );
      })
    );

/**
 * fetching menu items based on their privileges
 */

 /**
 * redux action constants
 */
export const FETCH_MENU_ITEMS = "FETCH_MENU_ITEMS";
export const FETCH_MENU_ITEMS_SUCCESS = "FETCH_MENU_ITEMS_SUCCESS";
export const FETCH_MENU_ITEMS_ERROR = "FETCH_MENU_ITEMS_ERROR";

/**
 * redux action functions
 */
export const fetchMenuItems = (): FetchMenuItemsAction => ({ type: FETCH_MENU_ITEMS });
export const fetchMenuItemsSuccess = ( menu: MenuItem[]): FetchMenuItemsSuccessAction => ({ type: FETCH_MENU_ITEMS_SUCCESS, menu });
export const fetchMenuItemsError = ( error: Error ): FetchMenuItemsErrorAction => ({ type: FETCH_MENU_ITEMS_ERROR, error });

/**
 * redux observable epic
 */
export const fetchMenuItemsEpic = ( action$: Observable<FetchMenuActionTypes> ) =>
    action$.pipe(
        ofType( FETCH_MENU_ITEMS ),
        mergeMap( () =>
            ajax( APP_CONFIG.getRequestObject( APP_CONFIG.baseWeb + "views/menus" ) ).pipe(
                map( response => fetchMenuItemsSuccess( response.response as MenuItem[] ) ),
                catchError( error =>
                    of(
                        fetchMenuItemsError( error ),
                        eventNotificationShow(
                            EVENT_NOTIFICATION_TYPE.customAjaxError,
                            "Menu konnte nicht geladen werden."
                        )
                    )
                )
            )
        )
    );